import BG from '../bg/BG';
import Enemy from '../enemy/Enemy';
import GUI from '../gui/GUI';
import Heroes from '../heroes/Heroes';
import Tapper from '../tapper/Tapper';
import Configs from '../../../configs/Configs';
import VFX from '../vfx/VFX';
import Session from '../session/Session';
import BossTimer from '../gui/boss-timer/BossTimer';
import Story from '../story/Story';
import Enrage from '../gui/enrage/Enrage';
import BossSkip from '../gui/boss-skip/BossSkip';
import Leaderboard from '../leaderboard/Leaderboard';
import Friends from '../friends/Friends';
import {
    playerAttack,
    $playerProfile,
    tokenEarned,
    enemyKilled,
    syncPlayerGameData,
    $afkReward,
} from '../../../backend/store/playerProfile';
// import OutOfEnergy from '../panel-out-of-energy/OutOfEnergy';
import OutOfEnergy from '../popups/out-of-energy/OutOfEnergy';
import { SKILLS } from '../../../configs/Configs';
import Modules from '../gui/modules/Modules';
import Selector from '../gui/selector/Selector';
import Shop from '../popups/shop/Shop';
import { CurrentEnemy } from '../../../../types/alice-bob';
import { enemyKilledEffect } from '../../../../app/backend/store/enemy';
import { $playerConfig } from '../../../../app/backend/store';
import BackModal from '../popups/back-modal/BackModal';
import { getUpgradeSpecAlice } from '../../../../types/config';


export const EVENTS = {
    NEW_STAGE_STARTED: 'new_stage_started',
    NEW_CHAPTER_STARTED: 'new_chapter_started',
    BUSRT_COOLDOWN_START: 'burst_cooldown_start',
    SHOW_CUTSCENE: 'show_cutscene',
    OUT_OF_ENERGY: 'out_of_energy',
    SHOW_BACK_MODAL: 'show-back-modal',
};

export default class Controller {
    private scene: Phaser.Scene;
    private session!: Session;

    private gui!: GUI;
    private bg!: BG;
    private heroes!: Heroes;
    private enemy!: Enemy;
    private tapper!: Tapper;
    private vfx!: VFX;
    private story!: Story;
    private leaderboard!: Leaderboard;
    private friends!: Friends;
    private shop!: Shop;
    private outOfEnergy!: OutOfEnergy;
    private BackModal!: BackModal;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;

        this.setupListeners();
        this.prepare();

        this.setupAura();

        const { afk_reward, afk_time } = $afkReward.getState()
        if (afk_reward > 100) this.scene.events.emit(Controller.EVENTS.SHOW_BACK_MODAL, { afk_reward, afk_time });
    }

    static get EVENTS() {
        return EVENTS;
    }

    setupListeners() {
        this.scene.events.once('shutdown', this.destroy, this);
        this.scene.events.on(Tapper.EVENTS.TAP, this.onTap, this);
        this.scene.events.on(Enemy.EVENTS.KILLED, this.onEnemyKilled, this);
        this.scene.events.on(BossTimer.EVENTS.EXPIRED, this.onBossReset, this);
        this.scene.events.on(Enrage.EVENTS.HIT, this.onEnrageHit, this);
        this.scene.events.on(BossSkip.EVENTS.BOSS_SKIP_PRESSED, this.onBossReset, this);
    }

    async prepare(): Promise<void> {
        this.session = new Session(this.scene);
        this.gui = new GUI(this.scene);
        this.bg = new BG(this.scene);

        this.heroes = new Heroes(this.scene);
        this.enemy = new Enemy(this.scene);
        this.tapper = new Tapper(this.scene);
        this.vfx = new VFX(this.scene);
        this.story = new Story(this.scene);
        this.leaderboard = new Leaderboard(this.scene);
        this.friends = new Friends(this.scene);

        this.shop = new Shop(this.scene);
        this.outOfEnergy = new OutOfEnergy(this.scene);
        this.BackModal = new BackModal(this.scene);


        // let step = $playerProfile.getState().tutorial_step;
        // if (step === -1) this.scene.events.emit(Modules.EVENTS.SHOW_STORY, true);

        // this.startNewStage();
        this.lazyLoadAssets();
    }

    lazyLoadAssets(): void {
        this.scene.game.events.once('CHAPTER_ASSETS_LOADED', this.startNewChapter, this);
        this.scene.game.events.emit('LOAD_CHAPTER_ASSETS');
    }

    startNewChapter(): void {
        const currentChapter = $playerProfile.getState().current_chapter;
        const bg = $playerConfig.getState().chapters[currentChapter].chapter_background
        this.scene.events.emit(EVENTS.NEW_CHAPTER_STARTED, bg);
        this.scene.events.emit(Controller.EVENTS.SHOW_CUTSCENE, currentChapter);
        this.startNewStage()
    }

    startNewStage(): void {
        // lazy loader core
        // this.scene.scene.get('Lazyloader').events.emit('LOAD_CHAPTER_ASSETS');
        // this.scene.game.events.emit('LOAD_CHAPTER_ASSETS');

        // show hero selector when we reach chapter 3
        // console.log($playerProfile.getState().current_chapter);

        //TODO: 2 -> 6 ?
        // if ($playerProfile.getState().current_chapter >= 2) {
        //     this.scene.events.emit(Selector.EVENTS.SHOW);
        // }

        // advance stage
        // this.session.advanceStage();

        // get enemy config
        // let enemyConfigRaw = Configs.getEnemyByStage(this.session.chapter, this.session.stage);
        // const enemyConfig = {
        //     ...enemyConfigRaw,
        //     enemy_name: enemyConfigRaw.name,
        //     is_boss: enemyConfigRaw.isBoss,
        //     shift: enemyConfigRaw.shift ?? { x: 0, y: 0 },
        // };

        // update stage GUI
        // this.scene.events.emit(EVENTS.NEW_STAGE_STARTED, this.session.stage, nextEnemy.background);
        const { current_enemy } = $playerProfile.getState();
        // console.log('nextEnemy', current_enemy)
        // spawn new enemy
        this.enemy.spawn(current_enemy);

        // start boss timer if needed
        if (current_enemy.is_boss) {
            this.scene.events.emit(BossTimer.EVENTS.START, Configs.bossTime);
        }

        if (this.session.stage === 1) {
            let watchedFirstChapter = this.scene.game.storage.getItem('watchedFirstChapter') !== null;
            if (!watchedFirstChapter) this.scene.events.emit(EVENTS.SHOW_CUTSCENE, 1);
            this.scene.game.storage.setItem('watchedFirstChapter', true);
        }
    }

    onTap(): void {
        let result = this.heroes.selectedHeroAttack();
        if (!result) return;

        if ($playerProfile.getState().player_wallet.currency_energy <= 0) {
            this.scene.events.emit(EVENTS.OUT_OF_ENERGY);
            window.devtodev.customEvent("out_of_energy", {
                "stage": $playerProfile.getState().current_stage,
                "chapter": $playerProfile.getState().current_chapter,
            })
            window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
            return;
        }
        playerAttack(1);
        // if ($playerProfile.getState().player_wallet.currency_energy % 20 == 0) syncPlayerGameData();

        window.Telegram.WebApp.HapticFeedback.impactOccurred('soft');

        let heroId = this.heroes.selectedHero!.id;

        this.enemy.getHit(result.damage, result.isCrit, heroId, false);
    }

    setupAura() {
        this.scene.time.addEvent({
            delay: 500,
            callback: () => {
                const auraDamage = Math.floor(getUpgradeSpecAlice('aura_level', $playerProfile.getState().hero_alice.aura_level || 1, $playerProfile.getState().current_chapter).value / 2)
                this.enemy.getHit(auraDamage, false, 0, false, true);
            },
            callbackScope: this, // keep 'this' pointing to the scene
            loop: true // repeat forever
        });
    }

    onEnrageHit(): void {
        let damage = this.heroes.enrageDamage;
        let heroId = 1;

        this.enemy.getHit(damage, false, heroId, true);
    }

    async onEnemyKilled() {
        // const currentEnemy = $currentEnemy.getState();

        // let gold = currentEnemy.gold;
        // if (heroId === 0) {
        //     let skill = SKILLS.ALICE.EXTRA_GOLD;
        //     let level = Session.Instance.getSkillLevel(skill);
        //     gold += enemyConfig.gold;
        // }

        // Session.Instance.addGold(gold);
        // tokenEarned(gold);
        // enemyKilled();
        // Session.Instance.unlockChapter(enemyConfig.chapterToUnlock);

        // this.scene.events.emit(BossTimer.EVENTS.STOP);
        const data = await enemyKilledEffect({ killed: true })
        // console.log('current_stage', data.player.current_stage)
        if (data.player.current_stage == 0) {
            this.scene.events.emit(BossTimer.EVENTS.STOP);
            this.lazyLoadAssets();
        } else {
            this.startNewStage();
        }

        // this.startNewStage();
        // this.lazyLoadAssets();
    }

    async onBossReset() {
        const data = await enemyKilledEffect({ killed: false })

        let stageToGoBackTo = 0;
        for (let i = this.session.stage - 1; i > 0; i--) {
            if (i === 1) {
                stageToGoBackTo = 1;
                break;
            }
        }

        // small workaround
        if (stageToGoBackTo === 1) stageToGoBackTo = -1;

        this.session.stage = stageToGoBackTo;
        this.startNewStage();
    }

    destroy(): void {
        this.scene.events.off(Tapper.EVENTS.TAP, this.onTap, this);
        this.scene.events.off(Enemy.EVENTS.KILLED, this.onEnemyKilled, this);
        this.scene.events.off(BossTimer.EVENTS.EXPIRED, this.onBossReset, this);
        this.scene.events.off(Enrage.EVENTS.HIT, this.onEnrageHit, this);
        this.scene.events.off(BossSkip.EVENTS.BOSS_SKIP_PRESSED, this.onBossReset, this);
    }
}
